import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import * as React from 'react';
import classnames from 'classnames';
var overStyle = {
  position: 'relative',
  overflow: 'initial',
  top: 'unset',
  left: 'unset',
  zIndex: 'unset'
};
var defaultClx = 'roo-dropdown-menu roo-drop-menu';

var DropMenuList = function DropMenuList(props) {
  return /*#__PURE__*/React.createElement("ul", _Object$assign({}, props, {
    className: classnames(defaultClx, props.className),
    style: overStyle
  }));
};

export default DropMenuList;